import { themeStore } from "@/stores/theme";
import { WithClassName } from "@/types/base";
import { genBlock } from "@/utils/bem";
import { Box, Center, chakra } from "@chakra-ui/react";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React from "react";

const block = genBlock("c-separator");
const ISeparator: React.FC<WithClassName> = ({ className }) => {
  const { separatorColor } = themeStore.styles;
  return (
    <Center className={classNames(block(), className)}>
      <Box w="100%" h="0px" my="8px" borderTop="2px" borderColor={separatorColor}></Box>
    </Center>
  );
};

export const Separator = chakra(observer(ISeparator));
